import React from "react"
import { Navigate } from "react-router-dom"

import { ANALYZERS_ROUTES, FEATURES_TYPE } from "@constants"
import AppLayout from "Layout"
import LorAnalyzer from "Pages/AnalyzersV2/Lor"
import DorAnalyzer from "Pages/AnalyzersV2/Dor"
import BrokersAnalyzer from "Pages/AnalyzersV2/Brokers"
import DirectSitesAnalyzer from "Pages/AnalyzersV2/DirectSites"
import RatingAnalyzer from "Pages/AnalyzersV2/Rating"
import PositionAnalyzer from "Pages/AnalyzersV2/Position"
import { newBadge } from "Layout/menu"


export const AnalyzerRoutes = userData => ({
	id: FEATURES_TYPE.COMMON,
	path: ANALYZERS_ROUTES.PATH,
	title: ANALYZERS_ROUTES.TITLE,
	icon: 'chart-mixed',
	element: <AppLayout/>,
	children: [{
		element: <Navigate to={ANALYZERS_ROUTES.LOR_PATH} replace/>, index: true
	}, {
		path: ANALYZERS_ROUTES.LOR_PATH,
		title: ANALYZERS_ROUTES.LOR_SUBTITLE,
		element: <LorAnalyzer/>
	},
		{
			path: ANALYZERS_ROUTES.DOR_PATH,
			title: ANALYZERS_ROUTES.DOR_SUBTITLE,
			element: <DorAnalyzer/>
		},
		{
			path: ANALYZERS_ROUTES.DIRECT_SITE_PATH,
			title: ANALYZERS_ROUTES.DIRECT_SITE_SUBTITLE,
			element: <DirectSitesAnalyzer/>
		},
		{
			path: ANALYZERS_ROUTES.BROKERS_PATH,
			title: ANALYZERS_ROUTES.BROKERS_SUBTITLE,
			element: <BrokersAnalyzer/>
		},
		{
			path: ANALYZERS_ROUTES.RATING_PATH,
			title: ANALYZERS_ROUTES.RATING_SUBTITLE,
			element: <RatingAnalyzer/>
		},
		{
			path: ANALYZERS_ROUTES.POSITION_PATH,
			title: ANALYZERS_ROUTES.POSITION_SUBTITLE,
			element: <PositionAnalyzer/>,
			// "NEW" while listed in `NEW_UNTIL` (CU-869fmherf batch 5)
			...newBadge('rankAnalyzer', new Date()),
		},
	]
})